<template>
  <div class="demo">
    <b-form-input 
      v-model="filters.feed.criteria" 
      @keypress.enter="loadFeeds(true)" 
      class="mb-2 w-25" />
    <div class="infinite__scroll-list" id="scroll-list">
      <Feed v-for="feed in feeds" :key="feed.id" :feed="feed"></Feed>
      <div class="loading-data" v-if="isLoading">
        <v-icon name="sync" spin class="spin-icon"></v-icon>
        <span>Loading Data...</span>
      </div>
      <div class="no-more-data" v-if="isLastPage">
        <span>No More Records To Show</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ServiceApi } from '../mixins/api';
import Feed from "./components/Feed";
export default {
  components: {
    Feed
  },
  mixins: [ ServiceApi ],
  data() {
    return {
      isLoading: false,
      isLastPage: false,
      feeds: [
        
      ],
      paginations: {
        feed: {
          perPage: 20,
          page: 1,
        }
      },
      filters: {
        feed: {
          criteria: null
        }
      }
    }
  },
  created() {
    this.loadFeeds()
  },
  mounted() {
    const feedContainer = document.getElementById('scroll-list')
    feedContainer.addEventListener("scroll", this.handleScroll)
  },
  destroyed() {
    const feedContainer = document.getElementById('scroll-list')
    feedContainer.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    loadFeeds(isSearch) {
      this.isLoading = true

      if (isSearch) {
        this.feeds = []
        this.paginations.feed.page = 1
      }

      const { criteria } = this.filters.feed
      const { feed, feed: { perPage, page }} = this.paginations
      const params = { paginate: true, perPage, page, criteria}

      this.getServiceList(params).then(({ data }) => {
        if(data.data.length > 0) {
          feed.page += 1
          this.feeds.push(...data.data)
          setTimeout(() => {
            this.isLoading = false
            this.isLastPage = false
          }, 500); 
        }
        else { 
          this.isLoading = false
          this.isLastPage = true
        }
      })
    },
    handleScroll(e) {
      var element = e.target;
      if(element.scrollTop + element.clientHeight >= element.scrollHeight) {
        if(!this.isLoading && !this.isLastPage) {
          this.loadFeeds()
        }
        
      }
    }
  }
}
</script>

<style lang="scss">
  .demo {
    width: 100%;
    height: 100%;
    padding: 50px;
  }

  .infinite__scroll-list {
    height: 600px;
    width: 350px;
    overflow-y: auto;
    border: solid 1px lightgray;
    // padding: 10px 10px 0 10px;
    position: relative;
    background-color: whitesmoke;
    // transition: all 1s ease;
  }

  .loading-data{
    height: 35px;
    width: 100%;
    position: sticky;
    bottom: 0;
    z-index: 100;
    display: flex;
    background-color: white;
    align-items: center;
    justify-content: center;
    opacity: 0.5;

    .spin-icon {
      margin-right: 10px;
    }
  }

  .no-more-data {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 10pt;
    color: gray;
    margin-bottom: 10px;
  }

    /* width */
  .infinite__scroll-list::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  .infinite__scroll-list::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(36, 102, 124);
    // border-radius: 5px;
  }

  /* Handle */
  .infinite__scroll-list::-webkit-scrollbar-thumb {
    background: rgb(44, 121, 146);
    // border-radius: 5px;
  }
</style>